import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73f4f448"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "table-container-wrapper"
};
const _hoisted_3 = {
  class: "table-top-flex"
};
const _hoisted_4 = {
  class: "table-title"
};
const _hoisted_5 = {
  key: 0,
  class: "button-container"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import { warnListPage, updateAlarmDict } from "@/api/system1/role";
import { ref, unref, reactive, onMounted, computed } from "vue";
import { ElMessageBox, ElMessage } from 'element-plus';
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const form = ref(null);
    const store = useStore();
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '告警配置';
    });
    // 获取告警配置类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "执行器"
    }, {
      dictValue: 2,
      dictLabel: "杭州先锋"
    }, {
      dictValue: 3,
      dictLabel: "安可信"
    }, {
      dictValue: 4,
      dictLabel: "鑫豪斯"
    }, {
      dictValue: 5,
      dictLabel: "汉威"
    }, {
      dictValue: 6,
      dictLabel: "希尔得"
    }, {
      dictValue: 9,
      dictLabel: "其他"
    }]);
    const statusOptions3 = ref([{
      dictValue: 1,
      dictLabel: "是"
    }, {
      dictValue: 0,
      dictLabel: "否"
    }]);
    const statusOptions4 = ref([{
      dictValue: 1,
      dictLabel: "启用"
    }, {
      dictValue: 0,
      dictLabel: "不启用"
    }]);
    const state = reactive({
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 告警配置表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        vendorCode: ''
      },
      // 表单参数
      form: {
        alarmCode: "",
        //告警编码
        alarmLevel: "",
        //告警级别:1-致命;2-严重;3-一般;4-提示
        alarmName: "",
        //告警名称
        deviceModel: "",
        //设备型号
        needConfirm: 0,
        //需要人工确认;0-不需要;1-需要
        vendorName: "",
        //厂商名称:1-执行器/2-杭州先锋(AEP)/ 3-安可信/4-鑫豪斯/5-汉威/6-希尔得/9-其他")
        notifySms: '',
        //发送短信通知；0-否；1-是
        notifyWechat: '',
        //发送微信通知；0-否；1-是
        isEnabled: 1 //是否启用；0-不启用；1-启用
      },
      // 表单校验
      rules: {
        alarmLevel: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        needConfirm: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        notifySms: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        notifyWechat: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }]
      },
      saveLoading: false,
      saveLoading1: false,
      publicKey: '',
      searchFormData: [{
        prop: "vendorCode",
        label: "厂商名称",
        placeholder: "请选择厂商名称",
        type: "list",
        isSelect: false,
        filterable: true,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [],
      tableHeader: [{
        prop: "alarmCode",
        label: "告警编码"
      }, {
        prop: "alarmLevel",
        label: "告警级别",
        statusList: [{
          value: 1,
          label: "致命"
        }, {
          value: 2,
          label: "严重"
        }, {
          value: 3,
          label: "一般"
        }, {
          value: 4,
          label: "提示"
        }]
      }, {
        prop: "alarmName",
        label: "告警名称"
      }, {
        prop: "deviceModel",
        label: "设备型号"
      }, {
        prop: "vendorName",
        label: "厂商名称"
      }, {
        prop: "needConfirm",
        label: "是否需要人工确认",
        statusList: [{
          value: 1,
          label: "是"
        }, {
          value: 0,
          label: "否"
        }]
      }, {
        prop: "notifySms",
        label: "发送短信通知",
        statusList: [{
          value: 1,
          label: "是"
        }, {
          value: 0,
          label: "否"
        }]
      }, {
        prop: "notifyWechat",
        label: "发送微信通知",
        statusList: [{
          value: 1,
          label: "是"
        }, {
          value: 0,
          label: "否"
        }]
      }, {
        prop: "isEnabled",
        label: "是否启用",
        statusList: [{
          value: 1,
          label: "启用"
        }, {
          value: 0,
          label: "不启用"
        }]
      }, {
        prop: "operation",
        label: "操作",
        width: "80px",
        fixed: "right",
        operation: [{
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['sys:user:edit']
        }]
      }],
      formScopeData: [
      // {
      //   prop: "tenantId",
      //   label: "所属租户",
      //   placeholder: "请选择所属租户",
      //   span: 24,
      //   type: "list",
      //   multiple:false,
      //   isSelect: false,
      //   options: tenantInfos,
      //   props: { label: "tenantName", value: "tenantId" },
      //   change: () => { },
      //   span: 24,
      //   hideHandle() {
      //      return userType !=3||state.form.userType==3;//普通告警配置和租户管理员创告警配置隐藏所属租户,只有超管显示
      //   }
      // },
      {
        prop: "alarmLevel",
        label: "告警级别",
        placeholder: "请选择告警级别",
        type: "list",
        options: [{
          value: 1,
          label: "致命"
        }, {
          value: 2,
          label: "严重"
        }, {
          value: 3,
          label: "一般"
        }, {
          value: 4,
          label: "提示"
        }],
        props: {
          label: "label",
          value: "value"
        },
        isSelect: false,
        span: 24
      }, {
        prop: "needConfirm",
        label: "是否需要人工确认",
        placeholder: "请选择",
        type: "radio",
        isSelect: false,
        options: statusOptions3,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: val => {},
        span: 24
      }, {
        prop: "notifySms",
        label: "发送短信通知",
        placeholder: "请选择",
        type: "radio",
        isSelect: false,
        options: statusOptions3,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: val => {},
        span: 24
      }, {
        prop: "notifyWechat",
        label: "发送微信通知",
        placeholder: "请选择",
        type: "radio",
        isSelect: false,
        options: statusOptions3,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: val => {},
        span: 24
      }, {
        prop: "isEnabled",
        label: "是否启用",
        placeholder: "请选择",
        type: "radio",
        isSelect: false,
        options: statusOptions4,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: val => {},
        span: 24
      }]
    });
    onMounted(() => {});
    /** 查询告警配置列表 */
    const getList = function () {
      state.loading = true;
      warnListPage(state.queryParams).then(response => {
        state.roleList = {
          rows: response.data.records,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      reset();
    };

    // 表单重置
    const reset = function () {
      state.form = {
        alarmCode: "",
        alarmLevel: "",
        alarmName: "",
        deviceModel: "",
        needConfirm: 0,
        vendorName: "",
        notifySms: '',
        notifyWechat: ''
      };
      // 如果是租户管理员，设置默认租户ID
      // if (userType == 2) {
      //   const defaultTenantId = window.localStorage.getItem("tenantId");
      //   if (defaultTenantId) {
      //     state.form.tenantId = defaultTenantId;
      //   }
      // }
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        vendorCode: null
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };

    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.openDataScope = true;
      state.title = "修改告警配置";
      reset();
      state.form = {
        ...row
      };
    };
    /** 修改/新增告警配置提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          if (params.actOp == 1) {
            params.actAuditor = '';
          }
          if (state.form.id) {
            updateAlarmDict(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_Iconfont, {
        name: "a-weipeizhi1",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: false,
        columnSetting: false,
        onSelectionChange: handleSelectionChange
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.openDataScope = $event),
        size: "600px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formScopeData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};